import { isFeatureEnabled } from "./VelocityApi";
import { tryGetHostApi } from "./externalApi";
export async function getUserSettingsAsync(storageKey) {
    if (await isFeatureEnabled("Feature_PinMigration")) {
        const widgetPinningApi = await tryGetHostApi("PinMigration", 2, 2);
        if (widgetPinningApi) {
            return await widgetPinningApi.getUserSettings(storageKey);
        }
    }
    return "";
}
export async function isMigrationCompleteAsync(storageKey) {
    if (await isFeatureEnabled("Feature_PinMigration")) {
        const widgetPinningApi = await tryGetHostApi("PinMigration", 2, 2);
        if (widgetPinningApi) {
            return await widgetPinningApi.isMigrationComplete(storageKey);
        }
    }
    return false;
}
export async function setUserSettingsAsync(storageKey, widgetPinnedInfo) {
    if (await isFeatureEnabled("Feature_PinMigration")) {
        const widgetPinningApi = await tryGetHostApi("PinMigration", 2, 2);
        if (widgetPinningApi) {
            widgetPinningApi.setUserSettings(storageKey, widgetPinnedInfo);
        }
    }
}
